import ReportCard from "../../../../../../components/reports/report-card.jsx";

const CardsContent = ({ cards, columns = 3 }) => {
    return (
        <>
            <div className="flex flex-col">
                <div className={`grid grid-cols-${columns}`}>
                    {cards.map((card, index) => (
                        <ReportCard
                            key={index}
                            title={card.title}
                            idTitle={card.idTitle}
                            value={card.value}
                        />
                    ))}
                </div>
            </div>

            <div className="chart-divisor"/>
        </>
    );
};

export default CardsContent;